import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, ChevronRight, GraduationCap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, V1 } from "@/lib/api";

export default function ScholarshipExams() {
  const [exams, setExams] = useState([]);
  useEffect(() => {
    api.get(`${V1}/scholarship-exams?status=open`).then((r) => setExams(r.data || [])).catch(() => setExams([]));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12" data-testid="scholarship-exams-page">
      <div className="mb-10">
        <div className="overline text-accent mb-2">Bursluluk</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Açık Bursluluk Sınavları</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">
          Türkiye genelinde bursluluk fırsatı sunan tüm okulların açık başvuruları.
        </p>
      </div>
      <div className="grid gap-4">
        {exams.length === 0 && <div className="text-muted-foreground p-16 text-center">Aktif bursluluk sınavı bulunmuyor.</div>}
        {exams.map((e) => (
          <div key={e.id} className="rounded-xl border border-border bg-card p-6 flex flex-col md:flex-row md:items-center gap-6" data-testid={`exam-card-${e.id}`}>
            {e.school?.cover_url && (
              <img src={e.school.cover_url} className="h-28 w-40 object-cover rounded-lg border border-border" alt={e.school?.name} />
            )}
            <div className="flex-1">
              <div className="text-xs text-muted-foreground flex items-center gap-1 mb-1">
                <MapPin className="h-3 w-3" /> {e.school?.province} / {e.school?.district}
              </div>
              <div className="font-display font-bold text-lg">{e.title}</div>
              <div className="text-sm text-muted-foreground mt-1 line-clamp-2">{e.description}</div>
              <div className="mt-2 flex flex-wrap gap-3 text-xs text-muted-foreground">
                <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" /> {new Date(e.exam_date).toLocaleDateString("tr-TR")}</span>
                <span>Sınıflar: {(e.grade_levels || []).join(", ")}</span>
                <span>Kontenjan: {e.quota}</span>
              </div>
            </div>
            <div className="flex gap-2">
              <Button asChild variant="outline"><Link to={`/okul/${e.school?.slug}`}>Okul <ChevronRight className="h-4 w-4" /></Link></Button>
              <Button asChild data-testid={`apply-cta-${e.id}`}><Link to={`/basvuru/${e.id}`}>Başvur</Link></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
